import React from 'react';
import { MapPin, Phone, Globe, Clock } from 'lucide-react';

const LocalJaipurSection = () => {
  return (
    <section id="location" className="py-16 sm:py-24 bg-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-orange-600 rounded-full filter blur-3xl animate-pulse"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 mb-4">
            <MapPin className="w-4 h-4 sm:w-5 sm:h-5 text-red-500" />
            <span className="text-red-500 font-semibold text-xs sm:text-sm uppercase tracking-wider">Our Location</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4 sm:mb-6 px-4">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-orange-500">
              Offline Ethical Hacking Training
            </span>
            {' '}in Jaipur
            <span className="block mt-2 text-2xl sm:text-3xl lg:text-4xl">
              + Online Courses Across India
            </span>
          </h2>
          <p className="text-gray-400 text-sm sm:text-base lg:text-lg px-4">
            Visit our training center in Jaipur or join from anywhere in India with our online programs
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto">
          {/* Map Section */}
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-br from-red-600/20 to-orange-600/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all"></div>
            <div className="relative bg-gray-900/50 border-2 border-gray-800 hover:border-red-500/50 rounded-2xl overflow-hidden transition-all duration-300 shadow-2xl">
              <div className="aspect-video w-full">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3559.166952312924!2d75.7858863!3d26.866436299999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db550e77ff017%3A0x453758c840524c88!2sINDIAN%20CYBER%20CLUB%20TECHNOLOGIES!5e0!3m2!1sen!2sin!4v1769759572699!5m2!1sen!2sin"
                  width="100%" 
                  height="100%" 
                  style={{ border: 0 }} 
                  allowFullScreen="" 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                  className="w-full h-full"
                ></iframe>
              </div>
              <div className="bg-gradient-to-br from-gray-900 to-gray-950 p-4 sm:p-6 border-t-2 border-red-500/30">
                <div className="flex items-center gap-3 mb-2">
                  <MapPin className="w-5 h-5 text-red-500 flex-shrink-0" />
                  <h3 className="text-lg sm:text-xl font-black text-white">Indian Cyber Club Academy</h3>
                </div>
                <p className="text-sm sm:text-base text-gray-400 ml-8">
                  Jaipur, Rajasthan, India
                </p>
              </div>
            </div>
          </div>

          {/* Contact Info Section */}
          <div className="space-y-6">
            <div className="bg-gradient-to-br from-gray-900 to-gray-950 border-2 border-red-500/30 rounded-2xl p-6 sm:p-8 hover:border-red-500/50 transition-all duration-300 hover:shadow-2xl hover:shadow-red-500/20">
              <h3 className="text-2xl sm:text-3xl font-black text-white mb-6">
                Visit Us or Learn Online
              </h3>
              
              <div className="space-y-5">
                <div className="flex items-start gap-4 group">
                  <div className="w-12 h-12 bg-gradient-to-br from-red-600 to-orange-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                    <MapPin className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold mb-1">Address</h4>
                    <p className="text-gray-400 text-sm">
                      Indian Cyber Club Academy<br />
                      Jaipur, Rajasthan, India
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4 group">
                  <div className="w-12 h-12 bg-gradient-to-br from-red-600 to-orange-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                    <Phone className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold mb-1">Phone</h4>
                    <a 
                      href="tel:+919694612895" 
                      className="text-red-500 hover:text-red-400 text-sm font-semibold transition-colors"
                    >
                      +91-9694612895
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4 group">
                  <div className="w-12 h-12 bg-gradient-to-br from-red-600 to-orange-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                    <Globe className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold mb-1">Coverage</h4>
                    <p className="text-gray-400 text-sm">
                      Offline Training: Jaipur, Rajasthan<br />
                      Online Courses: All India & Global
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4 group">
                  <div className="w-12 h-12 bg-gradient-to-br from-red-600 to-orange-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                    <Clock className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold mb-1">Timing</h4>
                    <p className="text-gray-400 text-sm">
                      Monday - Sunday: 9:00 AM - 9:00 PM
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t border-gray-800">
                <div className="flex flex-col sm:flex-row gap-3">
                  <a
                    href="https://wa.me/919694612895"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white text-center px-6 py-3 rounded-lg font-semibold transition-all duration-300 shadow-lg shadow-red-500/30 hover:shadow-red-500/50 hover:scale-105"
                  >
                    Contact Us
                  </a>
                  <a
                    href="https://www.google.com/maps/dir//INDIAN+CYBER+CLUB+TECHNOLOGIES/@26.866436299999997,75.7858863,17z"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 bg-gray-800 hover:bg-gray-700 text-white text-center px-6 py-3 rounded-lg font-semibold transition-all duration-300 border-2 border-gray-700 hover:border-red-500/50"
                  >
                    Get Directions
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-red-600/10 to-orange-600/10 border-2 border-red-500/30 rounded-xl p-4 sm:p-6">
              <p className="text-sm sm:text-base text-gray-300 text-center">
                <span className="font-bold text-white">30,000+ students</span> trained from across India. Join India's most followed cybersecurity academy with <span className="font-bold text-white">340K+ Instagram community</span>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocalJaipurSection;
